import { z } from "zod";

export const TeamIdSchema = z.number().int().min(1).brand<'TeamId'>();

export type TeamId = z.infer<typeof TeamIdSchema>;
